import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../../models/https';
import { jobActiveShiftActions } from '../../../redux/slices/activeShiftsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetAllActiveShifts = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetAllActiveShiftsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching active shifts'
    );
  };

  const onGetAllActiveShiftsSuccess = (response: PaginatedResponse) => {
    console.log('Active shifts response:', response);

    const {
      numberOfElements,
      totalElements,
      first,
      last,
      totalPages,
      content,
    } = response;

    dispatch(
      jobActiveShiftActions.getJobActiveShift({
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        jobData: Array.isArray(content) ? content : [],
      })
    );
  };

  const getAllActiveShifts = async (): Promise<void> => {
    const url: HttpConfig = {
      url: `jobs-service/applications/active`,
      method: 'get',
    };

    return await request(
      url,
      onGetAllActiveShiftsSuccess,
      setLoading,
      onGetAllActiveShiftsError
    );
  };

  return { getAllActiveShifts, loading };
};

export default useGetAllActiveShifts;
